export const siteConfig = {
  name: 'Codefied',
  tagline: 'Operational Technology, Embedded Deeply.',
  description:
    'Supporting architecture, execution, and scalable product operations for modern engineering teams.',
  url: (import.meta.env.VITE_APP_URL as string | undefined) ?? 'https://codefied.com',
  nav: [
    { label: 'Back Office', href: '/back-office' },
    { label: 'Product Engineering', href: '/product-engineering' },
    // { label: 'Codefied Suite', href: '#suite', hasDropdown: true },
    { label: 'Products', href: '#products', hasDropdown: true },
    { label: 'Company', href: '#company', hasDropdown: true },
  ],
  socials: {
    github: 'https://github.com/codefied',
    twitter: 'https://twitter.com/codefied',
    linkedin: 'https://linkedin.com/company/codefied',
  },
} as const
